import React from 'react'
import UploadBarViewModel from './UploadBarViewModel'
import styles from './UploadBar.sass'
import Workspace from 'iam/models/Workspace'
import { observer } from 'mobx-react'
import { animated, useTransition } from 'react-spring'
import Spinner from 'components/Spinner'
import Icon from 'components/Icon'

interface UploadBarProps {
  vm: UploadBarViewModel
  targetWorkspace: Workspace
}

export default observer(function UploadBar({
  vm,
  targetWorkspace,
}: UploadBarProps) {
  const showUploadBar = !vm.hidden
  const autoDismiss = vm.autoDismiss
  const uploadStatusTransition = useTransition(showUploadBar ? [true] : [], {
    from: { transform: 'translateY(100%)' },
    enter: { transform: 'translateY(0px)' },
    leave: { transform: 'translateY(100%)' },
  })

  return (
    <>
      {uploadStatusTransition((style) => (
        <animated.div className={styles.container} style={style}>
          {vm.dragging && (
            <div className={styles.draggingFiles}>
              Drop your files to upload to {targetWorkspace.name} document
              center
            </div>
          )}
          {vm.uploading && (
            <div className={styles.inProgress}>
              <Spinner thickness={3} size={20} />
              <div className={styles.content}>
                <div>Uploading {vm.currentlyUploadingFile?.name}</div>
                {vm.docsPendingUpload > 0 && (
                  <>
                    <div> - </div>
                    <div className={styles.remainingCount}>
                      {vm.uploadQueueFiles.length} documents left
                    </div>
                  </>
                )}
              </div>
              <div
                className={styles.progress}
                style={{
                  transform: `translateX(${vm.uploadPercent}%)`,
                }}
              ></div>
            </div>
          )}
          {vm.resolved && vm.successUploads.length > 0 && (
            <div className={styles.resolved}>
              <div className={styles.resolvedInfo}>
                <Icon color="#70c79a" name="radio-checked" />
                <div>
                  {vm.successUploads.length > 1 && (
                    <>
                      Uploaded {vm.successUploads.length} files to{' '}
                      {targetWorkspace.name}
                    </>
                  )}
                  {vm.successUploads.length === 1 && (
                    <>
                      Uploaded {vm.successUploads[0]?.file.name} to{' '}
                      {targetWorkspace.name}
                    </>
                  )}
                </div>
              </div>
              <a
                className={styles.resolvedClose}
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  vm.setHidden()
                }}
              >
                {!autoDismiss && 'Close'}
              </a>
            </div>
          )}
        </animated.div>
      ))}
    </>
  )
})
